/// <amd-module name="Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { ITfsPageData } from "Tfs/Platform/Page";

export const TfsPageDataActionsCreator = {
    tfsPageDataInitialized: (tfsPageData?: ITfsPageData) => createAction(TfsPageDataActionTypes.TfsPageDataInitialized, tfsPageData)
};

export const enum TfsPageDataActionTypes {
    TfsPageDataInitialized = "TfsPageData/Initialized"
}

export type TfsPageDataAction = ActionsUnion<typeof TfsPageDataActionsCreator>;
